import api from '../utils/api';

export const shelfListingService = {
  suggest: async (payload) => {
    const res = await api.post('/seller/shelf-listings/suggest', payload);
    return res.data?.data;
  },

  marketReference: async (payload) => {
    const res = await api.post('/seller/shelf-listings/market-reference', payload);
    return res.data?.data;
  },

  priceCheck: async (payload) => {
    const res = await api.post('/seller/shelf-listings/price-check', payload);
    return res.data;
  },

  validateOemLabel: async (payload) => {
    const res = await api.post('/seller/shelf-listings/oem-label/validate', payload);
    return res.data;
  },

  publish: async (payload) => {
    const res = await api.post('/seller/shelf-listings/publish', payload);
    return res.data;
  },
};

export default shelfListingService;
